// extracted by mini-css-extract-plugin
export default {"root":"TopBar_root__1GCk4","left":"TopBar_left__2qvDM","goBackButton":"TopBar_goBackButton__60273"};